(function () {
  'use strict';
  var initial = document.querySelector('[data-cart-price-data]');
  var data;
  try { data = JSON.parse(initial.textContent); } catch (_) { return; }
  var regularPrices = new Map(data.items.map(function (item) { return [item.variant_id, item.regular_price]; }));
  var revision = 0, timer;
  function money(value) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:data.currency}).format(value / 100);
  }
  function amount(value, tag) {
    var node = document.createElement(tag || 'span');
    node.className = 'money';
    node.textContent = money(value);
    return node;
  }
  function prices(node, regular, current) {
    if (!node) return;
    node.replaceChildren();
    if (regular > current) { node.appendChild(amount(regular, 's')); node.appendChild(document.createTextNode(' ')); }
    node.appendChild(amount(current));
  }
  function render() {
    document.querySelectorAll('#cart-popup .cart-popup-ul-middle > li').forEach(function (row, index) {
      var item = data.items[index];
      var remove = row.querySelector('[data-variant]');
      if (item && remove && Number(remove.dataset.variant) === item.variant_id) prices(row.querySelector('.cart-item-price'), item.regular_line_price, item.final_line_price);
    });
    document.querySelectorAll('#cart_form [data-cart-price-key]').forEach(function (row, index) {
      var item = data.items.find(function (entry) { return entry.key === row.dataset.cartPriceKey; });
      if (!item && data.items[index] && data.items[index].variant_id === Number(row.dataset.cartPriceVariant)) item = data.items[index];
      if (!item) return;
      row.dataset.cartPriceKey = item.key;
      prices(row.querySelector('[data-cart-unit-price]'), item.regular_price, item.final_price);
      prices(row.querySelector('[data-cart-line-price]'), item.regular_line_price, item.final_line_price);
    });
    var popupTotal = document.querySelector('#cart-popup .cart-popup-ul-top');
    if (popupTotal && !popupTotal.querySelector('[data-cart-total-savings]')) {
      var savings = document.createElement('li');
      savings.className = 'cart-total-savings';
      savings.setAttribute('data-cart-total-savings', '');
      popupTotal.appendChild(savings);
    }
    document.querySelectorAll('[data-cart-total-savings]').forEach(function (node) {
      node.hidden = data.savings <= 0;
      node.replaceChildren(document.createTextNode('You save '), amount(data.savings));
    });
    document.querySelectorAll('#cart_form .subtotal-price').forEach(function (node) { node.replaceChildren(amount(data.total_price)); });
  }
  function refresh(cart) {
    var currentRevision = ++revision;
    if (cart && Array.isArray(cart.items)) {
      var regularTotal = 0;
      data = {currency:cart.currency || data.currency, total_price:cart.total_price, items:cart.items.map(function (item) {
        var regular = Math.max(regularPrices.get(item.variant_id) || 0, item.original_price);
        regularTotal += regular * item.quantity;
        return {key:item.key,variant_id:item.variant_id,regular_price:regular,final_price:item.final_price,regular_line_price:regular*item.quantity,final_line_price:item.final_line_price};
      })};
      data.savings = Math.max(0, regularTotal - cart.total_price);
    }
    // Run after the legacy quantity handler has finished updating the cart DOM.
    queueMicrotask(render);
    clearTimeout(timer);
    timer = setTimeout(async function () {
      try {
        var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var response = await fetch(route + 'cart?sections=cart-price-data', {cache:'no-store',headers:{Accept:'application/json'}});
        if (!response.ok) return;
        var sections = await response.json();
        var html = new DOMParser().parseFromString(sections['cart-price-data'] || '', 'text/html');
        var fresh = JSON.parse(html.querySelector('[data-cart-price-data]').textContent);
        if (currentRevision !== revision) return;
        data = fresh;
        data.items.forEach(function (item) { regularPrices.set(item.variant_id, item.regular_price); });
        render();
      } catch (_) { /* Keep the last confirmed cart prices if refreshing is unavailable. */ }
    }, 100);
  }
  document.addEventListener('textual:cart-updated', function (event) { refresh(event.detail); });
  document.addEventListener('textual:cart-popup-rendered', function (event) { refresh(event.detail); });
  render();
}());
